const thTH= {
    login: {
      title: 'ลงชื่อเข้าใช้',
      sign_in_btn: 'ลงชื่อเข้าใช้'
    },
    bar: {
        logout: 'ออกจากระบบ',
        languages: 'ภาษา',
        settings: 'เปิดการตั้งค่า'
    },
    language: {
      name: 'ภาษาไทย (TH)',
    },
    attributePage: {
        title: 'การเปลี่ยนแปลงคุณสมบัติ',
        viewChanges: 'ดูการเปลี่ยนแปลง',
        dateTime: 'วันที่',
        notificationType: 'ประเภทการแจ้งเตือน',
        notificationValue: 'ค่าการแจ้งเตือน',
        oldValue: 'ค่าเก่า',
        newValue: 'ค่าใหม่',
        accept: 'ยอมรับ',
        reject: 'ปฏิเสธ',
    },
    Home: 'หน้าหลัก',
    load: 'กำลังดำเนินการโหลดเริ่มต้น...',
    Requested: "ขอแล้ว",
    Viewed: "ดูแล้ว",
    Executing: "กำลังดำเนินการ",
    Completed: "เสร็จสมบูรณ์",
    Expired: "หมดอายุ",
    Cancelled: "ยกเลิกแล้ว",
    Error: "ข้อผิดพลาด",
    Rejected: "ปฏิเสธแล้ว",
    error: 'มีบางอย่างผิดพลาด โปรดลองอีกครั้งในภายหลัง',
    displayname: 'ชื่อที่แสดง',
    givenname: 'ชื่อ',
    surname: 'นามสกุล',
    email: 'อีเมล',
    mail: 'อีเมล',
    name: 'ชื่อ',
    firstname: 'ชื่อ',
    lastname: 'นามสกุล',
    footer_copyright: 'สงวนลิขสิทธิ์'
  };
  
  export default thTH;
  